<template>
  <section class="hero is-small bg-orange is-bold">
    <div class="hero-body">
      <div class="container has-text-white">
        <slot name="topbar"></slot>
        <div class="columns">
          <article class="column is-6 is-offset-3">
            <h1 class="title is-size-1-desktop">
              <slot name="title"></slot>
            </h1>
            <h2 class="subtitle is-size-4">
              <slot name="subtitle"></slot>
            </h2>

            <slot name="description"></slot>
          </article>
        </div>
        <slot name="bottombar"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
